import { useId } from "react";
import { type SwitchProps } from "@radix-ui/react-switch";

import { switchVariant, type SwitchVariantProps } from "./switch.variants";

export type UseSwitchProps = SwitchVariantProps &
  SwitchProps & {
    className?: string;
    label?: string;
    disabled?: boolean;
  };

export const useSwitch = (props: UseSwitchProps) => {
  const { className = "", ...rest } = props;

  const id = useId();

  const styles = switchVariant({ disabled: rest.disabled });

  return {
    className,
    styles,
    id,
    ...rest,
  };
};
